<template>
	<div class="container">
		<div class="banner">
			<img :src="config.applyTemplateImg" alt="" />
		</div>
		<van-cell-group v-if="!isNewRecruitActivity">
			<van-cell>
				<template #title>
					<van-field class="name-input" @focus="nameInputing = true" maxlength="20" v-model.trim="name" label-width="88"
						@blur.native.capture="nameValidateAction" :error-message="nameValidate" placeholder="请输入家长姓名"><template
							#label>
							<span class="label">家长姓名</span>
						</template>
					</van-field>
				</template>
				<template #right-icon>
					<van-radio-group v-model="sexCode" direction="horizontal">
						<van-radio class="six-radio radio" v-for="item in sexDict" :key="item.code" :name="item.code">{{ item.name
							}}
							<template #icon="props">
								<img class="radio-icon" :src="requireIcon(props)" />
							</template>
						</van-radio>
					</van-radio-group>
				</template>
			</van-cell>
		</van-cell-group>
		<van-cell-group>
			<van-field v-model.trim="phone" label-width="88" type="tel" placeholder="请输入" @focus="phoneInputing = true"
				@blur.native.capture="phoneValidateAction" :error-message="phoneValidate">
				<template #label>
					<span class="label">联系电话</span>
				</template>
				<template #button v-if="isWx && isNewRecruitActivity">
					<div style="color: #456FEE;" @click="getWxPhone">授权手机号</div>
				</template>
			</van-field>
		</van-cell-group>
		<van-cell-group>
			<van-cell>
				<template #title>
					<van-field class="name-input" @focus="childNameInputing = true" maxlength="6" v-model.trim="childName"
						label-width="88" @blur.native.capture="childNameValidateAction" :error-message="childNameValidate"
						placeholder="请输入学生姓名"><template #label>
							<span class="label">学生姓名</span>
						</template>
					</van-field>
				</template>
			</van-cell>
		</van-cell-group>
		<van-cell-group>
			<van-cell class="grade-cell" title="学生年级" title-class="label grade-title" :border="false">
				<template #right-icon>
					<van-radio-group class="grade-radio-wrap" v-model="stage" direction="horizontal">
						<van-radio class="grad-radio radio" v-for="(item, index) in gradeDict" :key="index" :name="index">{{
				item.categoryName }}
							<template #icon="props">
								<img class="radio-icon" :src="requireIcon(props)" />
							</template>
						</van-radio>
					</van-radio-group>
				</template>
			</van-cell>
			<div class="grade-list">
				<div class="grade" v-for="item in gradeDict &&
				gradeDict[stage] &&
				gradeDict[stage].dictList" :key="item.code" :class="gradeCode == item.code && 'active'"
					@click="selectGrade(item.code)">
					{{ item.name }}
				</div>
			</div>

			<van-cell class="grade-cell" title="薄弱学科" title-class="label grade-title" :border="false">
				<template #right-icon>
					<van-radio-group class="grade-radio-wrap" v-model="subjectCode" direction="horizontal">
						<van-radio class="grad-radio radio"
							v-for="(item, index) in gradeDict && gradeDict[stage] && gradeDict[stage].subjectList" :key="index"
							:name="item.code">{{ item.name }}
							<template #icon="props">
								<img class="radio-icon" :src="requireIcon(props)" />
							</template>
						</van-radio>
					</van-radio-group>
				</template>
			</van-cell>
		</van-cell-group>

		<van-cell-group>
			<van-field v-model="address" readonly label-width="88" is-link @click="onAreaInput">
				<template #input>
					<span v-if="formatAddress" class="black">{{ formatAddress }}</span>
					<span v-else :class="areaInputing && !areaCode ? 'placeholder error' : 'placeholder'
				">请选择/省/市/区</span>
				</template>
				<template #label>
					<span class="label">所在地区</span>
				</template>
			</van-field>
			<van-popup v-model="showAddressPopup" round position="bottom">
				<van-area :value="areaCode" :area-list="options" @confirm="onConfirmSelect" @cancel="onCancelSelect" />
			</van-popup>
		</van-cell-group>
		<div class="empty-placeholder"></div>
		<van-popup v-model="showSuccess" :style="{ background: 'none' }">
			<div class="succeed" @click="onHideSucceed">
				<img class="icon" src="../../assets/ic_succeed@2x.png" alt="" />
				<p class="hint">报名成功</p>
			</div>
		</van-popup>
		<div class="submit-wrapper">
			<van-button @click="onSubmit" class="submit" :color="canSubmit ? '#456FEE' : '#CCCCCC'"
				type="primary">提交</van-button>
		</div>
	</div>
</template>

<script>
import {
	map,
	prop,
	flow,
	join,
	isEmpty,
	last,
	first,
	findIndex,
	find,
	replace,
	nth,
} from "lodash/fp";
import {
	getAreaList,
	applyActivity,
	getAuthKey,
} from "../../axios/Activity/index";
import { normalize, formatterPoint, toQueryString } from "../../utils/tools";
import {
	trackerConfig,
	PAGE_EXPOSE,
	BUTTON_CLICK,
	ELEMENT_EXPOSE,
} from "../../utils/bigDataSdk";
import { parseAddress, signature } from "./utils";
import { getLocation } from "../../utils/wx";

const validPhone = (phone) => /^1[3-9]\d{9}$/.test(phone);
const validName = (name) => /^[\u4E00-\u9FA5A-Za-z]+$/gi.test(name);

export default {
	data() {
		return {
			name: "",
			nameInputing: false,
			childName: "",
			childNameInputing: false,
			phone: "",
			phoneInputing: false,
			sexCode: null,
			gradeCode: null,
			subjectCode: null,
			areaCode: null,
			showAddressPopup: false,
			address: "",
			cascaderValue: "",
			showSuccess: false,
			stage: 0,
			options: {}, // 省市区选择数据
			meta: {},
			uid: "",
			areaInputing: false,
			nameValidate: "",
			childNameValidate: "",
			phoneValidate: "",
			accessKey: "", // 表单提交的key
			isNewRecruitActivity: false,
			isWx: false
		};
	},

	created() {
		const ua = navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == "micromessenger") {
			wx.miniProgram.getEnv((res) => {
				if (res.miniprogram) {
					this.isWx = true
				}
			});
		}
	},

	mounted() {
		const query = this.$route.query || {};
		// 获取url参数
		const {
			longitude,
			latitude,
			token,
			avatar,
			phone,
			unionid: unionId,
			network_id: netWorkId,
			guide_id: guideId,
			guide_name: guideName,
			activity_code: activityCode,
			nickname: nickName,
			channel_code: channelCode,
			activity_url: activityUrl,
			activity_id: activityId,
			activity_name: activityName,
			resource_id: resourceId,
			resource_name: resourceName,
			source_id: sourceId,
			source_type: sourceType,
			address,
			link_id: linkId,
			recruitActivityVersion,
			childName,
			subjectCode,
			gradeCode,
			areaCode,
			formAddress,
			stage
		} = query;

		this.tracker = trackerConfig({
			pageName: "报名表单页",
			pageId: "40002",
			pageTitle: "填写报名信息",
			pageGuideId: guideId,
			pageGuideName: guideName,
			activityId,
			activityName,
			resourceId,
			resourceName,
		});

		this.phone = phone;
		this.childName = childName;
		this.subjectCode = subjectCode ? Number(subjectCode) : '';
		this.gradeCode = gradeCode ? Number(gradeCode) : '';
		this.stage = stage ? Number(stage) : 0;
		this.areaCode = areaCode;
		this.address = formAddress;
		this.activityId = activityId;
		this.isNewRecruitActivity = Boolean(recruitActivityVersion === 'new')
		const base = {
			point: formatterPoint(longitude, latitude),
			unionId,
			guideId,
			linkId,
			netWorkId,
			activitySource: this.isNewRecruitActivity ? 'RecruitmentLinkV1' : ''
		};
		this.base = base;
		this.recommendMeta = {
			...base,
			token,
		};
		this.meta = {
			...base,
			activityCode,
			nickName,
			avatar: decodeURIComponent(avatar || "") || null,
			channelCode,
			activityUrl: decodeURIComponent(activityUrl || "") || null,
			sourceId,
			sourceType,
			originalAddress: address,
		};
		this.getConfig({
			...base,
			phone,
			activityId: this.activityId,
			activityCode,
			originalAddress: address,
		});
		getAreaList().then((res) => {
			this.options = {
				city_list: prop("data.cityList")(res),
				province_list: prop("data.provinceList")(res),
				county_list: prop("data.countyList")(res),
			};
		});
		this.tracker({
			eventKey: PAGE_EXPOSE,
		});
		getAuthKey().then((res) => {
			this.accessKey = res.data;
		});
	},
	computed: {
		// 姓名和电话号码必填
		canSubmit() {
			return (
				(this.isNewRecruitActivity || (!isEmpty(this.name) && isEmpty(this.nameValidate) &&
					this.name.length >= 2)) &&
				validPhone(this.phone) &&
				!isEmpty(this.areaCode) &&
				!isEmpty(this.childName) &&
				isEmpty(this.childNameValidate)
			);
		},
		config() {
			return {
				...prop("$store.state.activity.config")(this),
				// applyTemplateCode: "1"
			};
		},
		formatAddress() {
			return this.address || parseAddress(this.areaCode, this.options);
		},
		sexDict() {
			return prop("$store.state.activity.config.sexDict.dictList")(this) || [];
		},
		sexDictMap() {
			return normalize(
				prop("$store.state.activity.config.sexDict.dictList")(this) || [],
				"code"
			);
		},
		gradeDict() {
			return prop("$store.state.activity.config.gradeDict")(this) || [];
		},
		gradeDictMap() {
			return normalize(
				prop(`$store.state.activity.config.gradeDict[${this.stage}].dictList`)(
					this
				) || [],
				"code"
			);
		},
		subjectDictMap() {
			return normalize(
				prop(`$store.state.activity.config.gradeDict[${this.stage}].subjectList`)(
					this
				) || [],
				"code"
			);
		}
	},
	methods: {
		// 小程序中重新授权手机号
		getWxPhone() {
			const query = {
				...(this.$route.query || {}),
				areaCode: this.areaCode || '',
				formAddress: this.address || '',
				gradeCode: this.gradeCode || '',
				subjectCode: this.subjectCode || '',
				sexCode: this.sexCode || '',
				childName: this.childName || '',
				phone: this.phone || '',
				stage: this.stage,
			}
			const url = `${window.location.origin}${window.location.pathname}#/clue-input/?${toQueryString(query)}`
			console.log(url)
			wx.miniProgram.redirectTo({
				url: '/subpackage_second_page/pages/recruitActivityPhone/index?url=' + encodeURIComponent(url)
			})
		},
		// 全部选项选择完毕后，会触发 finish 事件
		onConfirmSelect(e) {
			this.showAddressPopup = false;
			if (!e[0]) {
				return;
			}
			this.address = flow(
				map(prop("name")),
				join("/")
			)(e);
			this.areaCode = flow(
				last,
				prop("code")
			)(e);
		},
		onCancelSelect() {
			this.showAddressPopup = false;
		},
		onAreaInput() {
			if (!this.areaCode) {
				// 如果是微信环境，则调用微信SDK获取经纬度，自动回填信息
				if (navigator.userAgent.toLowerCase().indexOf("micromessenger") != -1 && window.self === window.top) {
					getLocation()
						.then((res) => {
							const { latitude, longitude } = res;
							this.getConfig(
								{
									...this.base,
									point: formatterPoint(longitude, latitude),
									activityId: this.activityId,
								},
								true
							);
						})
						.catch(() => {
							this.showAddressPopup = true;
						});
				} else {
					this.showAddressPopup = true;
				}
			} else {
				this.showAddressPopup = true;
			}

			this.areaInputing = true;
		},

		async onSubmit() {
			if (this.submiting) {
				return;
			} else {
				this.submiting = true;
			}
			if (!this.canSubmit) {
				this.submiting = false;
				return;
			}
			const baseMeta = {
				areaCode: this.areaCode,
				gradeCode: this.gradeCode,
				subjectCode: this.subjectCode,
				sexCode: this.sexCode,
				phone: this.phone,
				name: this.name,
				childName: this.childName,
			};
			const signatureKey = signature({
				...baseMeta,
				accessKey: this.accessKey,
			});
			let meta = {
				...this.meta,
				...baseMeta,
				address: this.formatAddress,
				activityId: this.activityId,
				signature: signatureKey,
				accessKey: this.accessKey,
				token: this.recommendMeta.token,
			};
			// 如果当前报名也模式为推荐导购，需要先调用接口查询推荐导购信息，将该导购信息传给报名接口
			if (prop("applyTemplateCode")(this.config) == "2") {
				try {
					const res =
						(await this.$store.dispatch({
							type: "getRecommendUserInfo",
							meta: {
								...(this.recommendMeta || {}),
								areaCode: this.areaCode,
								activityId: this.activityId,
							},
						})) || {};
					if (res.errcode === 0 && res.data) {
						meta = { ...meta, guideId: res.data.guideId };
					} else {
						this.$toast({
							message: "系统繁忙，请重试！",
							type: "fail",
						});
						this.submiting = false;
						return;
					}
				} catch (error) {
					this.$toast({
						message: "系统繁忙，请重试！",
						type: "fail",
					});
					this.submiting = false;
					return;
				}
			}

			applyActivity(meta)
				.then(({ errcode, errmsg } = {}) => {
					this.tracker({
						eventKey: BUTTON_CLICK,
						buttonName: "提交",
						buttonContent: "提交",
						name: this.name,
						childName: this.childName,
						sex: prop(`${this.sexCode}.name`)(this.sexDictMap),
						phone: this.phone,
						studySection: prop("categoryName")(nth(this.stage)(this.gradeDict)),
						gradeName: prop(`${this.gradeCode}.name`)(this.gradeDictMap),
						subjecName: prop(`${this.subjectCode}.name`)(this.subjectDictMap),
						address: this.formatAddress,
					});
					if (errcode != 0) {
						return this.$toast({
							message: errmsg,
							type: "fail",
						});
					} else {
						const queryParam = flow(
							replace("/clue-input/?", ""),
							replace("/?", "")
						)(this.$route.fullPath);
						if (
							prop("applyTemplateCode")(this.config) == "2" ||
							prop("applyTemplateCode")(this.config) == "3"
						) {
							this.showSuccess = true;
							this.tracker({
								eventKey: ELEMENT_EXPOSE,
								elementType: "toast",
								elementName: "报名成功",
								elementContent: "报名成功",
							});
							setTimeout(() => {
								this.$router.replace({
									path: `/result?template=${prop("applyTemplateCode")(
										this.config
									)}&${queryParam}`,
								});
							}, 1000);
						} else {
							this.$router.replace({
								path: `/result?template=${prop("applyTemplateCode")(
									this.config
								)}&${queryParam}`,
							});
						}
					}
				})
				.catch(({ errmsg } = {}) => {
					this.$toast({
						message: errmsg,
						type: "fail",
					});
				})
				.finally(() => {
					this.submiting = false;
				});
		},
		onHideSucceed() {
			this.showSuccess = false;
		},
		requireIcon(props) {
			return require(`@/assets/radio${props.checked ? "_active" : ""}.png`);
		},
		selectGrade(e) {
			this.gradeCode = e;
		},
		nameValidateAction() {
			if (this.nameInputing && isEmpty(this.name)) {
				this.nameValidate = "家长姓名不能为空";
			} else if (this.nameInputing && !validName(this.name)) {
				this.nameValidate = "不能有特殊字符";
			} else if (this.nameInputing && this.name.length < 2) {
				this.nameValidate = "不能少于两个字符";
			} else {
				this.nameValidate = "";
			}
		},
		childNameValidateAction() {
			if (this.childNameInputing && isEmpty(this.childName)) {
				this.childNameValidate = "学生姓名不能为空";
			} else if (this.childNameInputing && !validName(this.childName)) {
				this.childNameValidate = "不能有特殊字符";
			} else {
				this.childNameValidate = "";
			}
		},
		phoneValidateAction() {
			if (
				this.phoneInputing &&
				(isEmpty(this.phone) || !validPhone(this.phone))
			) {
				this.phoneValidate = "请输入11位手机号";
			} else {
				this.phoneValidate = "";
			}
		},

		getConfig(meta, onlyAreaCode = false) {
			this.$store
				.dispatch({
					type: "getActivityApplyConfig",
					meta,
				})
				.then((res) => {
					if (prop("errcode")(res) != 0) {
						getAuthKey().then((res) => {
							this.accessKey = res.data;
						});
						this.$toast({
							message: prop("errmsg")(res),
							type: "fail",
						});
					} else {
						// 用户已报名过活动，回填用户的报名数据
						let applyInfo = prop("data.applyedInfo")(res);
						if (!onlyAreaCode) {
							// 如果是新版招募链接，需要回填url上数据
							if (this.$route.query.recruitActivityVersion === 'new') {
								// 手机号有，但是无其他信息，回填手机号
								if (this.$route.query.phone !== undefined && this.$route.query.formAddress === undefined) {
									applyInfo = {
										...(applyInfo || {}),
										phone: this.phone
									}
								}
								if (this.$route.query.formAddress !== undefined) {
									applyInfo = {
										...(applyInfo || {}),
										name: this.name,
										childName: this.childName,
										phone: this.phone,
										address: this.address,
										sexCode: this.sexCode,
										gradeCode: this.gradeCode,
										subjectCode: this.subjectCode,
										areaCode: this.areaCode
									}
								}
							}
							this.name = prop("name")(applyInfo) || this.name;
							this.childName = prop("childName")(applyInfo) || this.childName;
							this.phone = prop("phone")(applyInfo) || this.phone;
							this.address = prop("address")(applyInfo);

							this.sexCode =
								prop("sexCode")(applyInfo) ||
								flow(
									prop("data.sexDict.dictList"),
									first,
									prop("code")
								)(res);
							const gradeCode =
								prop("gradeCode")(applyInfo) ||
								flow(
									prop("data.gradeDict"),
									first,
									prop("dictList"),
									first,
									prop("code")
								)(res);
							this.gradeCode = gradeCode;
							const subjectCode =
								prop("subjectCode")(applyInfo) ||
								flow(
									prop("data.gradeDict"),
									first,
									prop("subjectList"),
									first,
									prop("code")
								)(res);
							this.subjectCode = subjectCode;
							const stage =
								findIndex((item) => {
									return find((grade) => prop("code")(grade) == gradeCode)(
										prop("dictList")(item)
									);
								})(prop("data.gradeDict")(res)) || 0;
							this.stage = stage < 0 ? 0 : stage;
						}
						this.areaCode =
							prop("areaCode")(applyInfo) ||
							prop("data.recommendAreaCode")(res);
					}
				})
				.catch((e) => {
					this.$toast({
						message: e,
						type: "fail",
					});
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.banner {
	width: 100%;
	min-height: 60px;

	img {
		width: 100%;
	}
}

.submit-wrapper {
	width: 100%;
	box-sizing: border-box;
	padding: 0 20px 40px;
}

.submit {
	width: 100%;
}

.succeed {
	width: 130px;
	height: 130px;
	background: #ffffff;
	border-radius: 12px;
	text-align: center;
	padding-top: 18px;
	box-sizing: border-box;

	.icon {
		widows: 50px;
		height: 58px;
	}

	.hint {
		margin-top: 17px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #34404a;
	}
}

.grade-list {
	display: flex;
	padding: 0 24px;
	justify-content: space-between;
	flex-wrap: wrap;
}

.grade-list:last-child {
	padding-bottom: 21px;
}

.grade {
	font-size: 14px;
	font-family: PingFang SC;
	font-weight: 500;
	color: #333333;
	line-height: 34px;
	width: calc((100% - 24px) / 3);
	height: 34px;
	text-align: center;
	background: #f5f5f7;
	border: 1px solid #f5f5f7;
	border-radius: 6px;
	margin-bottom: 8px;
}

.grade.active {
	color: #456fee;
	border: 1px solid #456fee;
}

.van-cell {
	padding: 21px 24px;
	align-items: center;
}

.name-input {
	padding: 0;
}

.radio-icon {
	width: 16px;
	height: 16px;
}

.black {
	color: #333;
}

.label {
	color: #333333 !important;
	font-weight: bold;
}

.radio {
	font-weight: bold;
	color: #333;
}

.grad-radio {
	margin-right: 0;
}

.six-radio {
	margin-right: 0;
}

.six-radio:last-child {
	margin-left: 27.5px;
}

.grade-title {
	width: 100px;
	flex: initial;
}

.grade-radio-wrap {
	justify-content: space-between;
	flex: 1;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-row-gap: 10px;
}

.placeholder {
	color: #999999;
}

.empty-placeholder {
	height: 20px;
	width: 100%;
}

.error {
	color: #ee0a24;
}

// 屏幕宽度小于350时适配
@media screen and (max-width: 374px) {
	.six-radio:last-child {
		margin-left: 7px;
	}

	.van-field__label {
		width: 60px !important;
	}

	.van-cell {
		padding: 21px 10px;
		align-items: center;
	}

	.grade-list {
		padding: 0 10px;
	}

	.submit-wrapper {
		padding: 0 10px 40px;
	}

	.name-input {
		padding: 0;
	}
}
</style>
